import { RouteRecordRaw } from 'vue-router'

const profileRoutes: Array<RouteRecordRaw> = [
  {
    path: '/profile',
    meta: { requiresAuth: true },
    name: 'profile layout',
    component: () => import('@/views/profile/ProfileLayout.vue'),
    children: [
      {
        path: ':id',
        name: 'profileHome',
        component: () => import('@/views/profile/ProfileHome.vue'),
      },
      {
        path: ':id/manage',
        name: 'profileManage',
        component: () => import('@/views/profile/ProfileManage.vue'),
      },
      {
        path: ':id/add',
        name: 'profileAdd',
        component: () => import('@/views/profile/ProfileAdd.vue'),
      },
      {
        path: ':id/edit',
        name: 'profileEdit',
        component: () => import('@/views/profile/ProfileAdd.vue'),
      },
      {
        path: ':id/help-preferences',
        name: 'helpPreferences',
        component: () => import('@/views/profile/HelpAndPreferencesPage.vue'),
      },
      {
        path: ':id/restart-budget',
        name: 'restartBudget',
        component: () => import('@/views/profile/RestartBudgetPage.vue'),
      },
      {
        path: ':invalidPath(.*)*',
        redirect: (to) => {
          // Redirects back to the parent profile page
          return { path: `/profile/${to.params.id}` }
        },
      },
    ],
  },
]

export default profileRoutes
